/** Locale configuration shared by routing and dependency-free utility modules. */
export const APP_LOCALES = ['en', 'de', 'it', 'es', 'fr'] as const;
export const DEFAULT_APP_LOCALE = 'en' as const;

export type AppLocale = (typeof APP_LOCALES)[number];

export function isAppLocale(locale: string): locale is AppLocale {
    return APP_LOCALES.includes(locale as AppLocale);
}


